var map = {
	"./SpielkarteTAN.png": "78f4",
	"./ani1frame-old.png": "d597",
	"./ani1frame.png": "0b42",
	"./code-de.png": "2b84",
	"./code-en.png": "5c9b",
	"./code-fr.png": "c427",
	"./code-it.png": "2c87",
	"./de.png": "ce65",
	"./druck.png": "155f",
	"./druck80.png": "3394",
	"./en.png": "70ff",
	"./fr.png": "410f",
	"./handy.png": "3764",
	"./handy80.png": "48af",
	"./it.png": "1dc1",
	"./logo-future.png": "221f",
	"./man.png": "d378",
	"./mme-schachtel.png": "0d5e",
	"./naechster.png": "762d",
	"./sms.png": "077a",
	"./sms80.png": "d75d",
	"./web_button.png": "a9bf",
	"./web_button80.png": "8205",
	"./women.png": "1d57"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7b1d";